import { jsx as _jsx } from "react/jsx-runtime";
import _toConsumableArray from "/tmp/builds/n85FxqY8/0/kreezus/calendar/calendar-api/node_modules/next/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _defineProperty from "/tmp/builds/n85FxqY8/0/kreezus/calendar/calendar-api/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

// https://markk.dev/blogs/setting-up-google-analytics-react-next-js
import React, { useState, useEffect, useCallback } from 'react';
import Router from 'next/router';
import ReactGA from 'react-ga';
var TrackingContext = /*#__PURE__*/React.createContext({
  addTracker: function addTracker() {
    return void 0;
  },
  removeTracker: undefined,
  logEvent: function logEvent(args) {
    return void 0;
  }
});

function TrackingProvider(props) {
  var TrackingID = props.browserConfigProps.googleAnalyticsTrackingCode; // if the userId is passed in, we'll need to keep track of any
  // login/logout changes
  // another method is presented below, this will vary depending
  // on your authentication method
  // const { userIdThatMightChange } = props;
  // we create a default state to keep track of whether GA
  // has been initialized, if we're tracking a unique user,
  // and to hold all of our trackers

  var _useState = useState({
    isInitialized: false,
    hasUser: false,
    trackers: ['myDefaultTracker']
  }),
      analytics = _useState[0],
      setAnalytics = _useState[1]; // We create a function handle all route changes that occur
  // and track a users movements across pages in our app


  var handleRouteChange = useCallback(function (url) {
    ReactGA.set({
      page: url
    }, analytics.trackers);
    ReactGA.set({
      anonymizeIp: false
    });
    ReactGA.pageview(url, analytics.trackers);
  }, [analytics.trackers]);

  var addTracker = function addTracker(trackerId, trackerName) {
    if (analytics.isInitialized) {
      ReactGA.addTrackers([{
        trackingId: trackerId,
        gaOptions: {
          name: trackerName
        }
      }]);
      setAnalytics(function (prev) {
        return _objectSpread(_objectSpread({}, prev), {}, {
          trackers: [].concat(_toConsumableArray(prev.trackers), [trackerName])
        });
      });
    }
  };

  var removeTracker = function removeTracker(trackerName) {
    if (analytics.isInitialized) {
      setAnalytics(function (prev) {
        return _objectSpread(_objectSpread({}, prev), {}, {
          trackers: prev.trackers.filter(function (tracker) {
            return tracker !== trackerName;
          })
        });
      });
    }
  };

  var logEvent = function logEvent(_ref) {
    var _ref$category = _ref.category,
        category = _ref$category === void 0 ? '' : _ref$category,
        _ref$action = _ref.action,
        action = _ref$action === void 0 ? '' : _ref$action,
        _ref$label = _ref.label,
        label = _ref$label === void 0 ? '' : _ref$label;

    if (analytics.isInitialized) {
      ReactGA.event({
        category: category,
        action: action,
        label: label
      }, analytics.trackers);
    }
  }; // We only want to initialize GA on the client side
  // This will fail if you're trying to initialize server side
  // useEffect will help us handle this case as it only runs
  // client side


  useEffect(function () {
    var isInitialized = analytics.isInitialized,
        hasUser = analytics.hasUser,
        trackers = analytics.trackers; // How you detect which user is currently logged in
    // depends on the way you've set up authentication within
    // your app, the important thing is getting the userId
    // initialize GA with our tracking id
    // uncomment the user tracking method that works for you

    if (TrackingID && !isInitialized) {
      TrackingID && ReactGA.initialize(TrackingID, {
        gaOptions: {// userId: userIdThatMightChange
        }
      }); // Handle all route changes

      Router.events.on('routeChangeComplete', handleRouteChange);
      setAnalytics(function (prev) {
        return _objectSpread(_objectSpread({}, prev), {}, {
          isInitialized: true,
          hasUser: false
        });
      }); // in case we dont have the user initially,
      // we handle setting a user in our tracker
    } else if (isInitialized && !hasUser) {
      setAnalytics(function (prev) {
        return _objectSpread(_objectSpread({}, prev), {}, {
          hasUser: Boolean(false)
        });
      });
    }

    return function () {
      // clean up
      Router.events.off('routeChangeComplete', handleRouteChange);
    }; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return /*#__PURE__*/_jsx(TrackingContext.Provider, _objectSpread({
    value: {
      addTracker: addTracker,
      removeTracker: removeTracker,
      logEvent: logEvent
    }
  }, props));
}

var useTracking = function useTracking() {
  return React.useContext(TrackingContext);
};

export { TrackingProvider, useTracking };